var exports = {
  "i": "xa15a2ab7--2d7392--wrapper",
};

module.exports = exports;
